// Full-document render of the store-locator stores list, inside PageSkeleton.
// Simple copy is ttag `t`; the title blocktrans (inline <br>/<a> markup)
// arrives pre-localized as `title_html` so its exact msgid keeps its fr_CA
// translation.
import React from "react";
import { t } from "ttag";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";

// Mutable reactivated props (not Immutable<>): composes PageSkeleton.
type IProps = templates.StoresListTemplate;

export const Template = (props: IProps): React.JSX.Element => {
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <div className="store-locator">
                <div className="store-locator__hero l-full-width">
                    <div className="store-locator__hero-title">
                        {t`Find a Retailer`}
                    </div>
                </div>

                <div className="l-capped-width">
                    <nav
                        className="breadcrumb"
                        role="region"
                        aria-label={t`breadcrumbs`}
                    >
                        <ul className="breadcrumb__list">
                            <li className="breadcrumb__list-item">
                                <a href={props.home_url}>{t`Home`}</a>
                            </li>
                            <li className="breadcrumb__list-item">
                                <a href={props.store_locator_url}>
                                    {t`Store Locator`}
                                </a>
                            </li>
                            <li className="breadcrumb__list-item">
                                <a href={props.find_retailer_url}>
                                    {t`Find a Retailer`}
                                </a>
                            </li>
                            <li className="breadcrumb__list-item">
                                <a href={props.state_url}>{props.state_name}</a>
                            </li>
                            <li
                                className="breadcrumb__list-item"
                                aria-current="page"
                            >
                                <a href={props.city_url}>{props.city_name}</a>
                            </li>
                        </ul>
                    </nav>

                    <div className="store-locator__header">
                        <h1
                            className="store-locator__title"
                            dangerouslySetInnerHTML={{
                                __html: props.title_html,
                            }}
                        />
                        <p className="store-locator__description">
                            {t`Browse state-by-state, city-by-city, for the Tempur-Pedic retailer of your choice.`}
                        </p>
                    </div>

                    <div className="store-locator__list">
                        <p className="store-locator__list-label">
                            {t`Select a Retailer:`}
                        </p>
                        <div className="store-locator__list-container">
                            {props.stores.map((store) => (
                                <span
                                    key={store.url}
                                    className="store-locator__list-item store-locator__list-item--store"
                                >
                                    <a
                                        className="store-locator__list-link"
                                        href={store.url}
                                    >
                                        {store.name}
                                    </a>
                                    <br />
                                    <span className="store-locator__list-link__address">
                                        {store.address}
                                        <br />
                                        {store.address2 && (
                                            <>
                                                {store.address2}
                                                <br />
                                            </>
                                        )}
                                        {store.city}, {store.state}{" "}
                                        {store.postal}
                                        <div>{store.phone}</div>
                                    </span>
                                </span>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </PageSkeleton>
    );
};
